import React, { forwardRef, useCallback, useEffect, useMemo, useState, } from 'react';
import cx from 'classnames';
import AccordionItem from './components/AccordionItem';
import { AccordionProvider } from './context';
import styles from './Accordion.module.scss';
const AccordionComponent = forwardRef(({ defaultExpanded = 'item', multiple = false, children, className, onExpandedChange, }, ref) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    const onToggleExpanded = useCallback((toExpand) => {
        if (multiple) {
            setExpanded((prev) => {
                if (prev && Array.isArray(prev)) {
                    return prev.includes(toExpand)
                        ? prev.filter((id) => id !== toExpand)
                        : [...prev, toExpand];
                }
                return [toExpand];
            });
        }
        else {
            setExpanded((prev) => (prev === toExpand ? null : toExpand));
        }
    }, [multiple]);
    useEffect(() => {
        if (onExpandedChange) {
            onExpandedChange(expanded);
        }
    }, [expanded]);
    const value = useMemo(() => ({
        expanded,
        onToggleExpanded,
        multiple,
    }), [expanded, onToggleExpanded]);
    return (React.createElement("div", { ref: ref, className: cx(styles.accordionContainer, className) },
        React.createElement(AccordionProvider.Provider, { value: value }, children)));
});
const Accordion = AccordionComponent;
Accordion.Item = AccordionItem;
export default Accordion;
